module.exports = __webpack_public_path__ + "img/baoli.700b6060.png";